import { newPageInfo, newRouteParamsType } from "@hex-insights/router";
import { Newsletter, NewsletterFormat, NewsletterNameFragment } from "@hex-insights/verita-romania.shared";
import { rootPageInfo } from "../../../../root.pageinfo";

type NewsletterForRouteTitle = NewsletterNameFragment;

export const newsletterHubDetailPageInfo = newPageInfo({
	name: "Newsletter Detail",
	title: (instance: NewsletterForRouteTitle) => NewsletterFormat.name(instance),
	description: "Newsletter detail page.",
	exact: false,
	isLeaf: true,
	parent: rootPageInfo,
	to: (id: Newsletter["id"]) => rootPageInfo.to + `newsletters/${id}`,
	path: rootPageInfo.path + "newsletters/:newsletterID(\\d+)",
	paramsType: newRouteParamsType(rootPageInfo.paramsType, "newsletterID"),
});
